import './input.js';
import './directives/inputDirectives.js';